import React from "react";
import { Icon } from "antd";
import {
  LocationStartIcon,
  LocationStopIcon,
  WarehouseIcon2,
} from "../../../common/CustomIcon";

const LHTracking = (props) => {
  const { orderResponse = {} } = props;
  const { linehaul_tracking_details: routeData = [] } = orderResponse;

  // Helper function to check if stop should be indented
  const shouldIndentStop = (stopType) => {
    const indentTypes = [
      "PICKUP_ORDER_STOP_OFF",
      "DELIVERY_ORDER_STOP_OFF",
      "PICKUP_STOP_OFF",
      "DELIVERY_STOP_OFF",
      "DRIVER_SWAP",
      "STOP_OFF"
    ];
    return indentTypes.includes(stopType);
  };

  const hasIndentStop = routeData.some((item) =>
    shouldIndentStop(item.stop_type)
  );

  const getStopIcon = (stopType,locationType, index, isLast) => {
    if(locationType === "WH") return <WarehouseIcon2 />;
    if (index === 0)
      return (
        <LocationStartIcon />
        // <Icon type="play-circle" theme="filled" style={{ fontSize: "24px" }} />
      );
    if (isLast) return <LocationStopIcon />;
    // <Icon type="pause-circle" theme="filled" style={{ fontSize: "24px" }} />
    // if (stopType === "DRIVER_SWAP")
    //   return <Icon type="car" className="route-icon" />;
    return <WarehouseIcon2 />;
  };

  const getStopTypeLabel = (stopType, index, isLast) => {
    if (index === 0) return "Pickup";
    if (isLast) return "Delivery";
    if (stopType === "DRIVER_SWAP") return "Driver Swap";
    return "Stop";
  };

  const formatAddress = (address) => {
    if (!address) return "";
    const parts = [];
    if (address.address_line1) parts.push(address.address_line1);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.zipcode) parts.push(address.zipcode);
    return parts.join(", ");
  };


  const getIndentedStopCount = () => {
    const indentTypes = [
      "PICKUP_ORDER_STOP_OFF",
      "DELIVERY_ORDER_STOP_OFF",
      "PICKUP_STOP_OFF",
      "DELIVERY_STOP_OFF",
      "DRIVER_SWAP",
      "STOP_OFF",
    ];
    // Count how many stops in the routeData have a stop_type that should be indented

    if (!routeData) return 0;
    if (!Array.isArray(routeData)) return 0;
    if (routeData.length === 0) return 0;

    return routeData.filter((stopType) =>
      indentTypes.includes(stopType.stop_type)
    ).length;
  };

  // Empty state component
  const EmptyTrackingState = () => (
    <div className="emptyDisplay">
      <div className="empty-tracking-state">
        <div className="empty-state-container">
          <div className="empty-state-icon">
            <Icon type="environment" />
          </div>
          <div className="empty-state-content">
            <h3 className="empty-state-title">
              No Tracking Information Available
            </h3>
            <p className="empty-state-description">
              Linehaul tracking details are not yet available for this order.
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  // Check if tracking data is empty or invalid
  const hasTrackingData =
    routeData && Array.isArray(routeData) && routeData.length > 0;

  // If no tracking data, show empty state
  if (!hasTrackingData) {
    return <EmptyTrackingState />;
  }

  return (
    <div className="route-visualization">
      <div className="route-container">
        <div className="vertical-line" />
        {routeData?.map((stop, index) => {
          const isLast = index === routeData.length - 1;
          const isIndented = shouldIndentStop(stop.stop_type);
          const indentedStopLength = getIndentedStopCount();
          const lastIndentedStopIndex = indentedStopLength + 1;
          const isLastIndentedStop = index === lastIndentedStopIndex;

          return (
            <div
              key={`${stop.location_code || stop.id || stop._id}-${index}-${
                stop.stop_type
              }`}
              className={`route-stop ${
                isIndented ? "route-stop--indented" : ""
              }`}
            >
              <div className="stop-content">
                <div className="stop-header">
                  <div className="stop-icon-container">
                    {getStopIcon(stop.stop_type,stop.location_type, index, isLast)}
                  </div>
                  <div className="stop-info">
                    <div className="stop-title">
                      <span className="location-code">
                        {stop.location_code || "Customer"}
                      </span>
                      <span className="location-address">
                        {formatAddress(stop.l_address)}
                      </span>
                    </div>
                    
                  </div>
                </div>

                <div className="stop-action">
                  <span className="action-badge">
                    {getStopTypeLabel(stop.stop_type, index, isLast)}
                  </span>
                </div>
                {hasIndentStop &&
                  !isLast &&
                  indentedStopLength &&
                  !isLastIndentedStop && <div className="connecting-line" />}
              </div>
              {!isLast && (
              <div className="stop-duration">
                {stop?.distance ? stop.distance : "--" } mi (Driver: {stop?.driver_name ? stop.driver_name : "--"})
              </div>
            )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LHTracking;
